import config from 'config/environment';

export const getTicketId = (input: string | number): string => {
  return config.TICKET_ID_PREFIX + input;
};
